<template>
    <div class="menu-modal-container">
        <div class="menu-modal-content menu-modal-content-background-warning">
            <div class="menu-modal-content-header">
                UMA
            </div>
            <div class="menu-modal-content-body">
                <div class="menu-modal-content-title">
                    <div class="menu-modal-icon menu-modal-icon-warning">
                        <span class="mdi mdi-exclamation-thick"></span>
                    </div>
                    <div class="menu-modal-content-title-text">
                        <p>{{ warningMessage }}</p>
                    </div>
                </div>
                <div v-if="closeWarning" class="menu-btn-modal-container">
                    <button class="menu-modal-btn menu-modal-confirm-btn" @click="closeWarning">Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WarningModal",
    props: {
        closeWarning: {
            type: Function,
            required: false,
        },
        warningMessage: {
            type: String,
            required: true,
        }
    },
};
</script>

<style scoped>

</style>